import * as React from "react";
import { MemoryRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../components/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import FormatTemplate from "./FormatTemplate";
import "../styles/globals.css";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute authenticatedElement={<FormatTemplate />} />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
